import { render } from "./ShippingMethodCustomers.vue?vue&type=template&id=19bde272&scoped=true&ts=true"
import script from "./ShippingMethodCustomers.vue?vue&type=script&lang=ts"
export * from "./ShippingMethodCustomers.vue?vue&type=script&lang=ts"

import "./ShippingMethodCustomers.vue?vue&type=style&index=0&id=19bde272&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\keisi\\keisishopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19bde272"]])

export default __exports__